import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const JobPage = lazy(() => import('@/pages/job/JobPage'))

/**
 * 스케줄러 관리 라우트
 * children 없이 flat하게 구성 → 사이드바에 화살표 안 나타남
 */
export const jobRoutes: RouteWithMeta[] = [
  {
    path: 'job',
    element: withSuspense(<JobPage/>),
    meta: {
      label: '스케줄러',
      showInMenu: false,
      icon: ''
    }
  },
]